import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function FSW_mobile_view_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-6'>1. Introduction</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to Full stack and its different tech, Basics of Full stack.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-6'>2. HTML</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          How internet works (browsing your web, domains and Ip address) Resources (Text editor,HTML tags).
          <br></br>HTML basics/intermediate & Advanced HTML( Meta data,forms,HTML Vs HTML5).
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-6'>3. CSS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction, syntax, inline, internal & external, Box Model) CSS3 (selectors, background, text, images, Bg images, Animations, CSS Grid & CSS Layout).            
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-6'>4. Bootstrap</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to Bootstrap, Installation, Grid system, Forms buttons & icons integration.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-6'>5. SAAS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to SAAS, Installation, Variable & nesting.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-6'>6. JAVA SCRIPT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to JavaScript and its basics, Numbers, strings, Boolean, comparison, variable, functions, arrays, objects, Loops, keywords, section outline documents, OOPs, Inheritance, constructor, destructor, encapsulation.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-6'>7. DOM</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to DOM & DOM manipulation, Dom, selectors, events, background generator & files.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-6'>8. JQUERY</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          jQuery basics, selectors, traversing, CSS, events, DOM, ajax.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel9bh-content"
          id="panel9bh-header"
        >
          <Typography className='fs-6'>9. NODE JS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to Node Js, Node Js Modules, ES6 Modules & its types, Building a server, Restful APIs, Middle wear functions, Express frameworks
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel10bh-content"
          id="panel10bh-header"
        >
          <Typography className='fs-6'>10. SQL</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to SQL and basics, creating tables & joining it, Delete & drop, Installing & using postre SQL (insert, select, alter, update, conditional selection, function).  
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel11'} onChange={handleChange('panel11')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel11bh-content"
          id="panel11bh-header"
        >
          <Typography className='fs-6'>11. React</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Front-end web development with React, Intro to full stack web development, Setting up git, basic git commands, Online git repositories Node.js and NPM. Front-end JavaScript frameworks & libraries, Overview to React & React app, JSX intro, react components (state & props) React component (Lifecycle methods).
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel12'} onChange={handleChange('panel12')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel12bh-content"
          id="panel12bh-header"
        >
          <Typography className='fs-6'>12. React Router & Single Page applications</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Presentational & container components, Functional components, React Virtual DOM, Header & Footer, React router & Parameters, Single page applications, Controlled Forms, Uncontrolled components.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel13'} onChange={handleChange('panel13')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel13bh-content"
          id="panel13bh-header"
        >
          <Typography className='fs-6'>13. Introduction to WordPress</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          WordPress and its history, WordPress vs. Websites, WordPress themes, finding domain registering a domain, Web hosting package, Installation of WordPress, Managing username & password.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel14'} onChange={handleChange('panel14')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel14bh-content"
          id="panel14bh-header"
        >
          <Typography className='fs-6'>14. Content Management in WordPress</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          WordPress tools for content, archiving content (categories, naming, creating new category, feed readers, RSS options and social media, picking text editor, picking a web browser, cross-browser) Setting FTP and transferring files.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel15'} onChange={handleChange('panel15')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel15bh-content"
          id="panel15bh-header"
        >
          <Typography className='fs-6'>15. Image formats</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Image Types & format and comparing, Image optimization and libraries with graphic design software, Color wheel, models, schemes and combinations. Installing fonts and web safe fonts for graphic design.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel16'} onChange={handleChange('panel16')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel16bh-content"
          id="panel16bh-header"
        >
          <Typography className='fs-6'>16. Designing & Layout</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Choosing different sites, Responsive layouts and display options, Layout and structure customizing header image or own header, custom navigation and themes to work on responsive page.
          </Typography>
        </AccordionDetails>
      </Accordion><Accordion className='py-2' expanded={expanded === 'panel17'} onChange={handleChange('panel17')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel17bh-content"
          id="panel17bh-header"
        >
          <Typography className='fs-6'>17. WordPress Content management & Plugins</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Creating font and static pages, blog pages and custom pages with templates. Sidebars and footer templates with sticky, category. Installing plugins and activating, Ecommerce plugins, photos galleries and portfolios. Inserting images onto pages and into posts integrating plugins with social networks.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel18'} onChange={handleChange('panel18')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel18bh-content"
          id="panel18bh-header"
        >
          <Typography className='fs-6'>18. Installing Plugins</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          WOO Commerce, basic setup, adding products, creating product page and side panel, single product page & checkout page. Adding payment gateway and pop-up notifications, custom mails.
          </Typography>
        </AccordionDetails>
      </Accordion><Accordion className='py-2' expanded={expanded === 'panel19'} onChange={handleChange('panel19')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel19bh-content"
          id="panel19bh-header"
        >
          <Typography className='fs-6'>19. DJANGO</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Django framework and its use, MVT Architecture, Django administration and inbuilt features, Migration, Database connectivity & ORM, Flow between Front end & back end, integrating front end framework I bootstrap and its validations
          </Typography>
        </AccordionDetails>
      </Accordion><Accordion className='py-2' expanded={expanded === 'panel20'} onChange={handleChange('panel20')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel20bh-content"
          id="panel20bh-header"
        >
          <Typography className='fs-6'>20. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project Overview.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
